import { extendTheme } from '@chakra-ui/react'
import styles from './styles'
import fonts from './fonts'
import colors from './colors'

const themeOverride = {
  styles,
  colors,
  fonts,
  components: {},
}

const theme = extendTheme(themeOverride)

export default theme
